import Card from './components/Cards/Card';
import Profile from './components/Profile/Profile';
import Sidebar from './components/Sidebar/Sidebar';

import './sass/App.scss';

function App() {
  return (
    <div className='container'>
      <Sidebar />
      <Profile />
      <div className="card-column">
        <Card />
      </div>
    </div>
  );
}

export default App;
